import React from 'react';
// import PropTypes from 'prop-types';
// import ReactDatePicker from 'react-date-picker';
// import Moment from 'moment';

import ReactDatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';
// const Example = () => {
//   const [startDate, setStartDate] = useState(new Date());
//   return (
//     <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
//   );
// };

// import { FaRegCalendarAlt } from 'react-icons/fa';
// eslint-disable-next-line no-unused-vars
import datepickercss from './datepicker.css';

const DatePicker = props => {
  const {
    title,
    date,
    onDateChange,
    disabled,
    minDate,
    maxDate,
    required,
    errorMessage,
    className,
    labelledBy,
    id,
  } = {
    ...props,
  };

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy');
  const customMask = () => {
    return (
      <MaskedInput
        pipe={autoCorrectedDatePipe}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        keepCharPositions
        guide
      />
    );
  };
  const disabledClass = disabled ? ' disabled' : '';
  const classes = errorMessage
    ? 'cdc-date-picker date-error ' + className
    : 'cdc-date-picker' + disabledClass + ' ' + className;

  return (
    <main>
      <div className={classes}>
        <header id={id}>{title}</header>
        <ReactDatePicker
          // calendarAriaLabel="Toggle calendar"
          // clearAriaLabel="Clear value"
          // dayAriaLabel="Day"
          // monthAriaLabel="Month"
          // nativeInputAriaLabel="Date"
          // dayPlaceholder="DD"
          // monthPlaceholder="MM"
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          yearDropdownItemNumber={15}
          scrollableYearDropdown
          placeholderText="DD/MM/20YY"
          onChange={onDateChange}
          selected={date}
          todayButton="Today"
          // calendarIcon={<FaRegCalendarAlt />}
          // yearAriaLabel="Year"
          customInput={customMask()}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          required={required}
          // openCalendarOnFocus={false}
          format="dd-MM-yyyy"
          aria-labelledby={labelledBy || id}
        />
        {errorMessage && <p className="error"> {errorMessage} </p>}
      </div>
    </main>
  );
};

export default DatePicker;
